module.exports = __webpack_public_path__ + "static/media/descrip2.c54f0514.jpg";